/**
 * What this tenant's surveys actually make available, derived from the
 * module-type flags `InsightsNavContext` reads off the availability endpoint.
 *
 * Shared (EL-1175) rather than re-derived per surface. The `/insights` sidebar
 * hid Segments for a KPI-only tenant while the overview's own action board
 * still advertised it, because the board never received these signals at all
 * and the `segmentable` rule lived as a one-line local in `AppSidebar`. One
 * definition, two readers.
 */
export interface ModuleTypeAvailability {
  surveyHasDrivers: boolean;
  surveyHasKpis: boolean;
}

/**
 * Whether segmentation is possible for this tenant.
 *
 * Needs BOTH module types: drivers are what people are clustered on, and a KPI
 * is what the resulting segments are ranked and statused against. A tenant
 * whose surveys are entirely KPI-typed (Engie's Human Energy Scans) cannot
 * produce segments at all — it is not merely empty for them — so every surface
 * must hide segmentation rather than link into a page that can only be blank.
 *
 * Both inputs default to `true` upstream while availability is loading or if
 * the request failed, so a slow response never makes a real entry disappear.
 */
export function isSegmentable({ surveyHasDrivers, surveyHasKpis }: ModuleTypeAvailability): boolean {
  return surveyHasDrivers && surveyHasKpis;
}
